// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  attachmentId: __t.u64().primaryKey().name("attachment_id"),
  messageId: __t.u64().name("message_id"),
  fileName: __t.string().name("file_name"),
  fileType: __t.string().name("file_type"),
  fileSize: __t.u64().name("file_size"),
  fileUrl: __t.string().name("file_url"),
  thumbnailUrl: __t.option(__t.string()).name("thumbnail_url"),
  uploadedAt: __t.timestamp().name("uploaded_at"),
});
